import { getProductPrice, isProductSubmission } from '../utils';

export function valueEqual(givenValue?: any, expectedValue?: any) {
  if (isProductSubmission(givenValue)) {
    return getProductPrice(givenValue) === expectedValue;
  }

  return givenValue === expectedValue;
}
